<template>
<div id="rate-plans" :class="{'pa-2 ma-2': $vuetify.breakpoint.smAndUp}">
    <im-header @add="addRatePlan()" :loading="loading">
        <template v-slot:title>
            <span> {{$t('rate_plans.title')}}</span>
        </template>
        <template v-slot:button-name>
            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('rate_plans.button.add_new') }}</span>
            <span v-else>{{ $t('rate_plans.button.add_new_short') }}</span>
        </template>
    </im-header>

    <v-container fluid>
        <v-row class="im-card-items">
            <template v-for="item in items">
                <v-col cols="12" sm="6" md="4" lg="3" :key="item.id">
                    <im-rate-plan-item :item="item" @edit="editRatePlan(item)" :class="{'net-admin': !admin && item.net_prices, 'im-card':true}" />
                </v-col>
            </template>
        </v-row>
    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMRatePlanItem from '../../components/items/RatePlanCardv2.vue';

export default {
    props: ['hotel'],
    name: `rate-plans`,

    components: {
        'im-header': IMHeader,
        'im-table-header': IMTableHeader,
        'im-rate-plan-item': IMRatePlanItem,
    },

    data() {
        return {
            admin: false,
            items: [],
            loading: null,
        };
    },

    watch: {
        '$route.params': {
            async handler(val) {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug);
                } else {
                    this.getAllItems();
                }
            },
            deep: true,
            immediate: true
        },
    },

    async mounted() {
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getAllItems() {
            this.loading = true;
            this.getItems();
            defaults.rate_plan_name = "";

        },

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {

                });
        },

        getItems() {
            if(!this.hotel.id) {
                this.loading = false;
                return;
            }

            // prepare stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        addRatePlan() {
            defaults.rate_plan_name = "Adauga Plan tarifar"
            this.$router.push({
                path: '/' + this.hotel.slug + '/rate-plans/create'
            });
        },

        editRatePlan(item) {
            if(this.admin) {
                defaults.rate_plan_name = item.name;
                this.$router.push({
                    path: '/' + this.hotel.slug + '/rate-plans/' + item.id,
                });
            } else {
                if(item.net_prices == false) {
                    defaults.rate_plan_name = item.name;
                    this.$router.push({
                        path: '/' + this.hotel.slug + '/rate-plans/' + item.id,
                    });
                }
            }
        },
    }
};
</script>
<style lang="stylus">
.net-admin
    .im-result
        background-color: rgba(0,0,0,0.1)
        opacity: 0.5
</style>
